export default "__VITE_ASSET__C$Wwpu3X__"